// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3M9Im","emails":"CreateEditClinics_emails__3rq63","emailTagLabel":"CreateEditClinics_emailTagLabel__3efnJ"};